export function hasTrial(subscription) {
  return subscription?.trialDuration?.value > 0;
}
